import React, { FC, useState } from 'react';
import DropdownWithSearch from 'components/dropdown-with-search/DropdownWithSearch';
import { joinTextArray } from 'utils/commonUtils';
import { pluckValuesFromArrayWithSpecificKey } from 'utils/formatters';
import { PayRunMemberHistoryActionTypes } from '../../constants';

export const ActionList = {
  [PayRunMemberHistoryActionTypes.JOB_STATUS_CHANGE]: 'Job Status Changes',
  [PayRunMemberHistoryActionTypes.MANAGE_ADJUSTMENT]: 'Adjustments',
  [PayRunMemberHistoryActionTypes.REPORT]: 'Reports',
  [PayRunMemberHistoryActionTypes.NOTE]: 'Notes',
  [PayRunMemberHistoryActionTypes.PAY_RUN_STATUS_CHANGE]: 'Pay Run Status Changes'
} as const;

export type PayRunHistoryActionTypes = typeof ActionList[keyof typeof ActionList];

interface ActionsFilterProps {
  selectedActions: string[];
  onSelectActions: (actions: string[]) => void;
}

const ActionsFilter: FC<ActionsFilterProps> = ({ selectedActions, onSelectActions }) => {
  const [actionsDraft, setActionsDraft] = useState<string[]>([]);

  const actionOptions = Object.entries(ActionList).map(([key, label]) => ({
    id: key,
    label: label,
    value: key
  }));

  const getTextForFilter = () => {
    return joinTextArray(
      pluckValuesFromArrayWithSpecificKey(
        actionOptions.filter(item => selectedActions.includes(item.value)),
        'label'
      )
    );
  };

  const handleActionsChange = (selected: string[]) => {
    onSelectActions(selected);
  };

  return (
    <div className="w-fit">
      <DropdownWithSearch
        data={actionOptions}
        dataKey="label"
        dataIdKey="value"
        selectedDraftArray={actionsDraft}
        setSelectedDraftArray={setActionsDraft}
        selectedArray={selectedActions}
        setSelectedArray={handleActionsChange}
        buttonPrimaryText="Actions"
        buttonSecondaryText={getTextForFilter()}
        filterPlaceholderText="Filter by actions"
        allowSearch={false}
        showResultsCount={false}
        filterId="history-tab-action-filter"
        filterPlaceholderStyle="font-semibold"
        customClassName="w-full"
      />
    </div>
  );
};

export default ActionsFilter;
